<template>
  <section>
    <div class="container-fluid white-bgcolor">
      <div class="row">
        <div class="col-12 menu-box">
          <ul>
            <li
              v-for="(wishlist, index) in wishlists"
              v-bind:key="index"
              :class="{ on: currentWishlist === index }"
              :id="'list-item-' + index"
              @click="currentWishlist = index">
                <h5 v-if="currentWishlist === 'wishlist'"
                    @click="showSaveWishlistForm = false"
                    class="text-center">
                      {{ $t("Wishlist." + index + ".title") }}
                </h5>
                <h5 v-else class="text-center">
                  {{ $t("Wishlist." + index + ".title") }}
                </h5>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div :ref="'wishlistContent'" class="container wishlist-content">
      <div class="row">
        <div class="col-12">
          <div class="container">
            <div
              v-if="
                currentWishlist === 'wishlist' ||
                currentWishlist === 'configure'
              "
              class="row">
                <div class="col-12 text-center">
                  <p v-if="wishlists[currentWishlist].length !== 0">
                    {{ wishlists[currentWishlist].length }}
                    {{
                      $tc("Wishlist.List.set", wishlists[currentWishlist].length)
                    }}
                  </p>
                  <p v-else><br /></p>
                </div>
            </div>
          </div>
          <div class="container">
            <div class="row" v-if="wishlists[currentWishlist].length === 0">
              <div v-if="currentWishlist !== 'load'" class="col-12">
                <p
                  class="empty"
                  :class="{ configure: currentWishlist === 'configure' }">
                    {{ $t("Wishlist." + currentWishlist + ".empty") }}
                </p>
              </div>
              <div v-if="currentWishlist !== 'configure'" class="col-12">
                <br />
                <br />
                <div class="col-12">
                  <h5>{{ $t("Wishlist.form.loadWishlist.title") }}:</h5>
                  <br />
                </div>
                <div id="loadList" class="form-horizontal">
                  <div class="form-group col-6 col-md-10">
                    <div class="col-12">
                      <input
                        v-model="code"
                        class="form-control"
                        type="text"
                        name="inputCode"
                        id="inputCode"
                        value=""
                        maxlength="8"
                        :placeholder="$t('Wishlist.form.loadWishlist.placeholder')"
                      />
                    </div>
                  </div>
                  <div class="form-group col-6 col-md-2">
                    <div class="col-12 text-end">
                      <button
                        type="submit"
                        class="btn btn-secondary btn-load-wishlist"
                        @click="loadWishlist(code)">
                          {{ $t("Wishlist.form.loadWishlist.buttonLoad") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template
              v-if="
                currentWishlist !== 'wishlist' ||
                (
                  currentWishlist === 'wishlist' &&
                  showSaveWishlistForm === false &&
                  showSaveWishlistResponse === false
                )
              ">
              <div
                class="row border-bottom wishlist-item"
                v-for="(item, itemIndex) in wishlists[currentWishlist]"
                v-bind:key="itemIndex">
                  <div class="col-12">
                    <h5>
                      {{ $tc("Wishlist.List.items", item.items.length) }}
                      {{ $d(item.date, "dateTime") }}
                    </h5>
                  </div>
                  <div class="col-6 col-lg-9">
                    <img
                      :src="getSrc(item)"
                      :ref="'wishlist_' + currentWishlist + '_' + itemIndex"
                      @error="
                        $refs[
                          'wishlist_' + currentWishlist + '_' + itemIndex
                        ][0].src = appUrl + '/img/assets/not-available.jpg'
                      "
                      @click="configure(item.primaryKey)"
                      class="thumb"
                      :alt="
                        item.items
                          .map((a) => a.itemnumber)
                          .join('_')
                          .toUpperCase()
                      "/>
                </div>
                <div class="col-6 col-lg-3 col-price">
                  <p class="price hidden">
                    {{ $n(item.totalPrice, "currency") }}
                  </p>
                  <div class="action text-center">
                    <a @click="configure(item.primaryKey)" class="btn btn-secondary btn-block">
                      {{ $t("Wishlist.List.button.configure") }}
                    </a>
                    <br />
                    <a @click="drop(item.primaryKey)" class="text-link">
                      {{ $t("Wishlist.List.button.drop") }}
                    </a>
                    <template v-if="item.setId && item.setId !== ''">
                      &nbsp;|&nbsp;
                      <a
                        :href="
                          '/artikel/' +
                          item.setId +
                          '_' +
                          (item.setParameter && item.setParameter.fineness
                            ? item.setParameter.fineness
                            : '') +
                          '_' +
                          (item.setParameter && item.setParameter.height
                            ? item.setParameter.height
                            : '') +
                          '_' +
                          (item.setParameter && item.setParameter.stoneQuality
                            ? item.setParameter.stoneQuality
                            : '') +
                          '_' +
                          (item.setParameter && item.setParameter.stonePriceType
                            ? item.setParameter.stonePriceType
                            : '') +
                          '/'
                        "
                        class="text-link">
                          Details
                      </a>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="showSaveWishlistResponse === true">
              <div class="row">
                <div class="col-12">
                  <div id="wishlistResponse" class="col-12 table-responsive">
                    <h5 id="titleSaveWishlist" class="text-center">
                      {{ $t("Wishlist.form.saveWishlistResponse.title") }}
                    </h5>
                    <p class="text-center">
                      {{ $t("Wishlist.form.saveWishlistResponse.message") }}
                    </p>
                    <table id="tableWishlistResponse" class="table">
                      <tr>
                        <td>ID:</td>
                        <td>{{ saveWishlistResponse.id }}</td>
                      </tr>
                      <tr>
                        <td>Code:</td>
                        <td>{{ saveWishlistResponse.code }}</td>
                      </tr>
                      <tr>
                        <td>Link:</td>
                        <td>
                          <a class="btn-link" :href="saveWishlistResponse.link">
                            {{ $t("Wishlist.form.saveWishlistResponse.linkWishlist") }}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-12 text-center">
                    <br />
                    <a class="btn btn-secondary" @click="showSaveWishlistResponse = false; showSaveWishlistForm = false;">
                        {{ $t("Wishlist.form.saveWishlistResponse.linkBack") }}
                    </a>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-12">
                  <br />
                  <div class="col-12">
                    <h5 id="titleSaveWishlist">
                      {{ $t("Wishlist.form.saveWishlist.title") }}
                    </h5>
                    <br />
                  </div>
                </div>
                <div id="saveList" class="row">
                  <div class="col-12">
                    <input
                      v-model="email"
                      class="form-control"
                      type="email"
                      name="inputEmail"
                      maxlength="255"
                      id="inputEmail"
                      value=""
                      :placeholder="$t('Wishlist.form.saveWishlist.placeholder')"
                    />
                    <input
                      v-model="emailRepeat"
                      type="email"
                      name="inputEmailRepeat"
                      maxlength="255"
                      class="form-control"
                      id="inputEmailRepeat"
                      value=""
                    />
                  </div>
                  <div class="col-12">
                    <input
                      v-model="name"
                      class="form-control"
                      type="text"
                      name="inputName"
                      maxlength="100"
                      id="inputName"
                      value=""
                      :placeholder="$t('Wishlist.form.saveWishlist.placeholderName')"
                    />
                  </div>

                  <div class="col-12" id="saveListActions">
                    <div class="row">
                      <div class="col col-sm-3 col-lg-2">
                        <button type="submit" class="btn btn-primary" @click="saveWishlist">
                          {{ $t("Wishlist.form.saveWishlist.buttonSave") }}
                        </button>
                      </div>
                      <div class="col col-sm-3 col-lg-2">
                        <button type="submit" class="btn btn-secondary" @click="showSaveWishlistForm = false">
                          {{ $t("Wishlist.form.abort") }}
                        </button>
                      </div>
                    </div>
                    <div class="small" style="margin-top: 0.5rem">
                      {{ $t("Wishlist.form.saveWishlist.privacyText.noEmailSaved") }}!
                      {{ $t("Wishlist.form.saveWishlist.privacyText.sendEmail") }}.
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="showSaveWishlistForm === false && showSaveWishlistResponse === false">
      <div class="row" v-if="wishlists[currentWishlist].length !== 0 && currentWishlist === 'wishlist'">
        <div class="col-12 wishlist-note-col">
          <h3>{{ $t("Wishlist.note.headline") }}</h3>
          <ul>
            <li>{{ $t("Wishlist.note.text1") }}</li>
            <li>{{ $t("Wishlist.note.text2") }}</li>
          </ul>
        </div>
      </div>
      <div v-if="isOnlyWishlist !== true" class="row mb-5" id="wishlistActions">
        <div v-if="currentWishlist === 'wishlist' && wishlists[currentWishlist].length > 0" class="col-12 col-lg-2">
          <a class="btn btn-primary" @click="showSaveWishlist">
            {{ $t("Wishlist.List.button.saveList") }}
          </a>
        </div>
        <div v-if="currentWishlist === 'configure'" class="col-12 col-lg-2">
          <a class="btn btn-primary" @click="currentWishlist = 'load'">
            {{ $t("Wishlist.List.button.loadList") }}
          </a>
        </div>
        <div v-if="currentWishlist !== 'load'" class="col-12 col-lg-2">
          <a class="btn btn-secondary" @click="closeWishlist">
            {{ $t("Common.all") }}
          </a>
        </div>
      </div>
      <div v-else class="row mb-5">
        <div v-if="currentWishlist === 'wishlist' && wishlists[currentWishlist].length > 0" class="col-12">
          <a class="btn btn-primary" @click="showSaveWishlist">
            {{ $t("Wishlist.List.button.saveList") }}
          </a>
        </div>
        <div v-if="currentWishlist === 'configure'" class="col-12">
          <a class="btn btn-primary" @click="currentWishlist = 'load'">
            {{ $t("Wishlist.List.button.loadList") }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Config from "@/vuex/Config";
import DAOWishlist from "@/../public/js/DAO/Wishlist.js";
import SetData from "@/vuex/SetData";
import Status from "@/vuex/Status";
import Notification from "@/assets/Helper/Notification";
import Logger from "@/assets/Helper/Logger";

export default {
  name: "Wishlist",
  data() {
    return {
      config: Config.getters.getConfig,
      getApiHost: Config.getters.getApiHost,
      appUrl: Config.getters.getAppUrl,
      set: SetData.getters.getSet,
      isOnlyWishlist: Config.getters.getIsOnlyWishlist,
      currentWishlist: "wishlist",
      showSaveWishlistForm: false,
      showSaveWishlistResponse: false,
      code: "",
      email: "",
      emailRepeat: "", // Honeypot Field
      name: "",
      wishlists: {
        configure: [],
        wishlist: [],
        load: [],
        //history: [] aktuell deaktiviert
      },
      saveWishlistResponse: {
        id: 0,
        name: "",
        code: "",
        email: "",
        hash: "",
        link: "",
      },
      wishlistAuth: {
        localStorageKey: "configurator2020",
      },
      sha256Regex: /^[a-f0-9]{64}$/gi,
    };
  },
  components: {},
  mounted() {
    if (this.isOnlyWishlist === true) {
      let hashFromConfig = "";
      if (
        typeof window.conf2020AppConfig.wishlist === "object" &&
        typeof window.conf2020AppConfig.wishlist.hash === "string"
      ) {
        hashFromConfig = window.conf2020AppConfig.wishlist.hash;
        window.conf2020AppConfig.wishlist.hash = "";
      }

      if (hashFromConfig != "") {
        this.setWishlistAuth(hashFromConfig);
        this.loadWishlist(hashFromConfig);

        this.currentWishlist = "wishlist";
      } else {
        this.currentWishlist = "wishlist";
      }
    }

    this.getOverview();

    this.$root.$on("wishlist", () => {
      this.getOverview();
    });

    this.$root.$on("closeWishlist", () => {
      this.closeWishlist();
    });

    this.$root.$on("lastConfigured", () => {
      this.currentWishlist = "configure";
    });

    this.$ga.page("/wishlist/" + this.currentWishlist);
  },
  methods: {
    saveWishlist: function () {
      DAOWishlist.getAll("wishlist").then((wishlist) => {
        this.email = this.email.trim();
        if (this.email === "" || this.email.indexOf("@") < 0) {
          Notification.create(
            this.$t("Wishlist.form.saveWishlist.notifications.wrongEmail")
          );
        } else if (wishlist && wishlist.length > 0) {
          let data = {
            wishlist: this.getWishlistForDB(wishlist),
            email: this.email,
            emailRepeat: this.emailRepeat,
            name: this.name,
            auth: this.getWishlistAuth(),
            website: Config.getters.getWebsite,
            country: Config.getters.getCountry,
            language: Config.getters.getLanguage,
            isShop: Config.getters.getActiveShop > 10000 ? 1 : 0,
          };

          this.saveWishlistResponse = {};

          DAOWishlist.saveWishlist(data, this.getApiHost).then((response) => {
            if (
              response &&
              response.status === true &&
              response.result &&
              response.result.id > 0
            ) {
              this.saveWishlistResponse = response.result;

              this.setWishlistAuth(response.result.hash);
              this.pushWishlistUri(response.result.code, response.result.hash);

              this.showSaveWishlistForm = false;
              this.showSaveWishlistResponse = true;
            } else {
              Notification.create(
                this.$t(
                  "Wishlist.form.saveWishlist.notifications.wishlistSaveError"
                )
              );
            }
          });
        } else {
          Notification.create(
            this.$t("Wishlist.form.saveWishlist.notifications.wishlistEmpty")
          );
        }
      });
    },
    showSaveWishlist: function () {
      this.showSaveWishlistForm = true;
      /*
      setTimeout(() => {
        this.$refs["wishlistContent"].scrollIntoView({
          block: "end",
          inline: "center",
        });
      });
      */
    },
    setWishlistAuth: function (wishlistAuth) {
      return DAOWishlist.setWishlistAuth(
        this.wishlistAuth.localStorageKey,
        wishlistAuth
      );
    },
    getWishlistAuth: function () {
      return DAOWishlist.getWishlistAuth(this.wishlistAuth.localStorageKey);
    },
    loadWishlist: function (auth) {
      let isAuthHash = this.sha256Regex.test(auth);

      if (
        (this.isOnlyWishlist === true && isAuthHash) ||
        confirm(
          this.$t("Wishlist.form.loadWishlist.notifications.clearWishlist")
        )
      ) {
        DAOWishlist.getWishlist({ auth: auth }, this.getApiHost).then(
          (response) => {
            if (response && response.status === true) {
              DAOWishlist.setWishlistFromDB(response.result.data).then(() => {
                DAOWishlist.setWishlistAuth(
                  this.wishlistAuth.localStorageKey,
                  response.result.hash
                );

                this.getOverview();

                this.currentWishlist = "wishlist";
                this.showSaveWishlistResponse = false;

                this.pushWishlistUri(auth, response.result.hash);
              });
            } else {
              Notification.create(
                this.$t("Wishlist.form.loadWishlist.notifications.errorOnLoad")
              );
            }
          }
        );
      }
    },
    pushWishlistUri: function (auth, hash) {
      if (
        this.isOnlyWishlist === true &&
        this.sha256Regex.test(auth) === false
      ) {
        // ignore direct link
        let wishlistUri = "/wishlist/" + hash + "/";
        window.history.pushState({ uri: wishlistUri }, "", wishlistUri);
      }
    },
    getWishlistForDB: function (wishlist) {
      let wishlistTmp = [];
      for (let i in wishlist) {
        wishlistTmp[i] = {
          date: wishlist[i].date,
          itemnumbersStart: wishlist[i].itemnumbersStart,
          items: wishlist[i].items,
          setId: wishlist[i].setId,
          setParameter: wishlist[i].setParameter,
          showSetIn3d: wishlist[i].showSetIn3d,
          totalPrice: wishlist[i].totalPrice,
        };
      }
      return wishlistTmp;
    },
    getSrc: function (item) {
      let tmpItems = [];
      let j = 0;
      for (let i in item.items) {
        tmpItems[j] = { itemnumber: item.items[i].itemnumber };
        j++;
      }

      if (tmpItems.length > 0) {
        return (
          this.getApiHost +
          "/v2/images/item/ffffff/600/600/" +
          tmpItems
            .map((a) => a.itemnumber)
            .join("_")
            .toUpperCase() +
          ".jpg"
        );
      } else {
        if (
          this.set.items[0].description.stones &&
          this.set.items[0].description.stones.diamondStock
        ) {
          return (
            this.appUrl +
            "/img/assets/stones/exchange/stone_" +
            this.set.items[0].description.stones.diamondStock.stoneform.toLowerCase() +
            ".jpg"
          );
        } else {
          return this.appUrl + "/img/assets/stones/exchange/stone_a.jpg";
        }
      }
    },
    closeWishlist: function () {
      Config.dispatch("setVisualMode", "show");

      setTimeout(() => {
        this.$root.$emit("setOverview");
        this.$root.$emit("checkWishlistIcon");
      }, 100);
    },
    configure: function (primaryKey) {
      Status.dispatch("setLoading", true);

      DAOWishlist.getByPrimaryKey(this.currentWishlist, primaryKey).then(
        (wishlistData) => {
          wishlistData.wishlistItemId = primaryKey;

          Status.dispatch("setIsInit", true);
          SetData.dispatch("setItemDescription3d", {});

          SetData.dispatch("restoreWishlistData", wishlistData)
            .then(() => {
              if (!Config.getters.getIsOnlyWishlist) {
                if (
                  SetData.getters.getShowSetImage === true &&
                  this.config.visualMode !== "images"
                ) {
                  this.$parent["setCurrentItem"]("set");
                } else {
                  this.$parent["setCurrentItem"]("overview");
                }

                Config.dispatch("setVisualMode", "show");
              }
              document.location.reload();
            })
            .catch((error) => {
              Logger.error(error);

              Status.dispatch("setLoading", false);
            });
        }
      );
    },
    drop: function (itemId) {
      DAOWishlist.drop(this.currentWishlist, itemId).then(() => {
        this.$root.$emit("wishlist");
        //Notification.create("Artikel entfernt");
      });
    },
    getOverview: function () {
      let componet = this;
      DAOWishlist.getAll("configure").then((items) => {
        componet.$data.wishlists.configure = items;
      });

      DAOWishlist.getAll("wishlist").then((items) => {
        componet.$data.wishlists.wishlist = items;
      });
      /*
      setTimeout(() => {
        this.$refs["wishlistContent"].scrollIntoView({
          block: "end",
          inline: "center",
        });
      });
      */
      /* aktuell deaktiviert
        DAOWishlist.getAll('history')
            .then(items => {
              componet.$data.wishlists.history = items;
            });
         */
    },
  },
  watch: {
    currentWishlist: {
      handler: function () {
        //let node = document.getElementById("list-item-" + this.currentWishlist);
        //node.scrollIntoView({ block: "end", inline: "center" });
        this.$ga.page("/wishlist/" + this.currentWishlist);
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .wishlist-content {
    padding-bottom: 4rem;

    .container:first-child {
      padding-top: 2rem;
    }

    .action {
      padding: 1.5rem;
    }

    .wishlist-item:last-child {
      border-bottom: none !important;
    }
  }

  .menu-box {
    padding: 2em 0 0 0;
    margin-bottom: 0;
    overflow: auto;
    height: max-content;
    text-align: center;
    border-bottom: solid 0.1em $brandDarkGrey;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: inline-block;
      width: max-content;
      text-align: center;

      li {
        margin: 0;
        padding: 0.2em 2em 1rem 2em;
        display: inline-block;
        line-height: 2em;
        cursor: pointer;
        color: $brandDarkGrey;
        letter-spacing: 0.1em;
      }

      li.on {
        border-bottom: none;
        font-weight: bold;
        color: $fontColor;

        h5 {
          color: $brandGold;
        }
      }
    }
  }

  #wishlistResponse {
    padding: 1rem;

    #tableWishlistResponse {
      margin-top: 1rem;

      tr {
        line-height: 2rem;

        td:first-child {
          width: 50%;
          text-align: right;
          font-weight: bold;
          border-bottom: 0.1rem solid #cccccc;
        }

        td {
          padding: 1rem;
        }
      }
    }
  }

  #titleSaveWishlist {
    line-height: 2rem;
  }

  #inputEmailRepeat {
    display: none;
  }

  #inputName {
    margin-top: 1rem;
  }

  #loadList,
  #saveList {
    display: flex;

    .btn-load-wishlist {
      margin-top: 0;
      margin-left: 0.5rem;
      width: 100%;
      height: 3.35rem;
    }

    input {
      font-size: 1.6rem;
      border-color: $brandDarkGrey;
    }
  }

  #saveList,
  #wishlistActions {
    margin-top: 1rem;

    .btn {
      width: 100%;
    }
  }

  #saveListActions {
    margin-top: 1rem;
  }

  .thumb {
    margin-top: 2em;
    width: 10em;
    cursor: pointer;
    height: auto;
  }

  .price {
    font-size: 1.8em;
    text-align: right;
  }

  .empty {
    line-height: 5rem;
    font-size: 1.6rem;
  }

  .wishlist-item {
    padding-bottom: 2rem;

    h5 {
      margin-bottom: 2rem;

      @media (min-width: 992px) {
        margin-bottom: 0;
      }
    }
  }

  .wishlist-note-col {
    ul {
      list-style-type: disc;
      padding-left: 1.5rem;

      li {
        margin-top: 0.5rem;
      }
    }
  }

  @media (min-width: 768px) {
    .col-price {
      padding-right: 3rem;
    }

    .btn-load {
      width: auto;
    }
  }

  @media (max-width: 350px) {
    .col-price {
      padding: 0;
    }
  }
}
</style>
